<template>
    <div class="main" id="app">
        <!-- home banner -->
        <home-bg v-if="routerName == 'home'" :scroll-top-num="scrollTopNum" />

        <!-- public header -->
        <header class="header" id="header">
            <div class="navbar-wrap" id="header_wrap">
                <div class="navbar" :class="{'for-fixed': headerFixed}">
                    <div class="header-inner maincon">
                        <i class="icon-logo" @click="routePush({name: 'home'})"></i>

                        <i class="btn-navbar font-icon" :class="{active: btnNavbarActive}" @click="toggleMenuForMobile(btnNavbarActive)"></i>

                        <!-- default -->
                        <div class="menu-skin menu-default">
                            <nav class="navigation">
                                <div v-for="(item, i) in menu" :key="i" :class="['menu-item', {'active': routerName == item.route, 'has-child': item.child}]" @click="routePush({name: item.route})">
                                    <div class="menu-con">
                                        <span class="menu-name">{{item.name}}</span>
                                        <i class="font-icon"></i>
                                    </div>
                                    <ul class="sub-menu" v-if="item.child">
                                        <li v-for="(child, index) in item.child" :key="index" :class="['sub-menu-item', {'active': (childPageScrollHash || routeHash) == child.hash}]" @click.stop="routePush({name: item.route, hash: '#'+child.hash})">{{child.name}}</li>
                                    </ul>
                                </div>
                            </nav>
                        </div>

                        <!-- for mobile -->
                        <div class="menu-skin menu-mobile" id="menu">
                            <nav class="navigation">
                                <div v-for="(item, i) in menu" :key="i" :class="['menu-item', {'active': routerName == item.route, 'has-child': item.child}]">
                                    <div class="menu-con" @click="routePush({name: item.route})">
                                        <span class="menu-name">{{item.name}}</span>
                                        <i class="font-icon" @click.stop="toggleSubMenu(i)"></i>
                                    </div>
                                    <ul class="sub-menu" :id="'submenu_'+i" v-if="item.child">
                                        <li v-for="(child, index) in item.child" :key="index" :class="['sub-menu-item', {'active': childPageScrollHash || routeHash == child.hash}]" @click="routePush(item.route + '#' + child.hash)">{{child.name}}</li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 面包屑 -->
            <div class="breadcrumb maincon" v-if="$route.meta.breadcrumb">
                <i class="font-icon icon-home" @click="routePush({name: 'home'})"></i>
                <i class="font-icon icon-right"></i>
                <span class="breadcrumb-text" title="You Are Here">{{$route.meta.breadcrumb}}</span>
            </div>
        </header>

        <router-view ref="child" :key="routerName"/>

        <!-- public footer -->
        <footer class="footer">
            <nav class="maincon">
                <a class="footer-item" v-for="(item, i) in menu" :key="i" @click="routePush({name: item.route})">{{item.name}}</a>
            </nav>
        </footer>
    </div>
</template>
  
<script>
import HomeBg from "./components/HomeBg";
export default {
    name: "app",
    components: {
        HomeBg
    },
    provide(){
        return {
            APP: this
        }  
    },
    data() {
        return {
            scrollTopNum: 0, //滚动值
            btnNavbarActive: false, //是否展示mobile下的菜单，mobile下使用
            headerFixed: false, //头部是否使用 fixed 定位

            childPageScrollHash: '', //service页面滚动时设置该值

            menu: [
                {name: 'home', route: 'home'},
                {name: 'services', route: 'services', child: [
                    {name: 'Customer Experience', hash: 'customer'},
                    {name: 'Contact Centre', hash: 'cc'},
                    {name: 'Strategy Design & Implementation', hash: 'strategy'},
                    {name: 'Business Process Mapping & Reengineering', hash: 'mapping'},
                    {name: 'Business Transformation', hash: 'transition'},
                    {name: 'Digital Transformation', hash: 'digital'},
                    {name: 'Artificial Intelligence', hash: 'ai'},
                    {name: 'Blockchain', hash: 'blockchain'}
                ]},
                {name: 'about us', route: 'about'},
                // {name: 'resources', route: 'resources'},
            ]
        };
    },
    computed: {
        routerName() {
            return this.$route.name;
        },
        routeHash(){
            return this.$route.hash.replace('#', '');
        },
    },
    watch: {
        routerName(){
            this.childPageScrollHash = '';
        }
    },
    created() {
        this.init();
    },
    destroyed(){
        window.removeEventListener("resize", this.flashHeaderStatus);
    },
    mounted(){
        this.flashHeaderStatus();
    },
    methods: {
        init() {
            $(document).ready(($) => {
                const $win = $(window);
                $win.scroll(() => {
                    this.scrollTopNum = $win.scrollTop();
                    this.flashHeaderStatus();
                });

                window.addEventListener('resize', this.flashHeaderStatus);
            });
        },

        /**设置头部定位状态 */
        flashHeaderStatus(arg){
            this.headerFixed = window.scrollY >= document.getElementById('header').offsetTop;
            const {flashWindow} = this.$refs.child;
            flashWindow && flashWindow(window.scrollY, arg);
        },

        /**收缩展示主菜单 */
        toggleMenuForMobile(val){
            this.btnNavbarActive = !val;
            this.$nextTick(()=>{
                $('#menu').slideToggle(!val);
            })
        },

        /**收缩展示子菜单 */
        toggleSubMenu(index){
            $('#submenu_'+index).slideToggle();
        },

        /**路由切换 */
        routePush(arg){
            this.childPageScrollHash = '';
            this.$router.push(arg);
        }
    }
};
</script>
  
<style lang="less">
    .navbar-wrap{height: 90px;}
    .navbar{border-bottom: 1px solid #ccc;background-color: #fff;box-shadow: 0 0.15em 0.35em 0 rgb(0 0 0 / 14%);}
    .header-inner{
        &{min-height: 90px;}
        &::after{content: '';clear: both;display: table;}
    }
    .for-fixed{position: fixed;top: 0;left: 0;right: 0;z-index: 1030;}
    .icon-logo{background-image: url('./assets/image/logo.png');width: 160px;height: 55px;margin-top: 22px;float: left;cursor: pointer;}
    .btn-navbar{
        &{display: none;float: right;font-size: 24px;color: #b7b7b7;background-color: #fff;box-shadow: inset 0 0 0 rgb(0 0 0 / 0%), 0 1px 5px rgb(0 0 0 / 25%);margin-top: 19px;border: 0;padding: 0.458em 0.625em;text-shadow: 0 1px 1px rgb(255 255 255 / 75%);border-radius: 4px;transition: box-shadow 0.3s ease, color 0.3s ease, background-color 0.3s ease;cursor: pointer;}
        &:before{content: "\f0c9";}
        &:hover, &.active{color: #919191;background-color: #f7f7f7;box-shadow: inset 0 1px 4px rgb(0 0 0 / 25%)}
    }

    .breadcrumb{
        &{font-size: 10px;padding: 10.5px 0;color: #272727;}
        .font-icon, .breadcrumb-text{display: inline-block;}
        .icon-home{
            &{cursor: pointer;}
            &:before{content: "\f015";}
        }
        .icon-right{
            &{margin: 0 2.5px 0 8px;}
            &::before{content: "\f105";}
        }
        .breadcrumb-text{color: #333;cursor: pointer;}
        .icon-home, .breadcrumb-text{
            &:hover{color: #f15a24;}
        }
    }
    
    // menu common
    .menu-skin{
        .menu-item{
            &{color: #272727;position: relative;cursor: pointer;}
            &:hover, &.active{
                .menu-name, .font-icon{color: #3993d1;}
            }
        }
        .menu-name{font-weight: 600;font-size: 14px;text-transform: uppercase;letter-spacing: 1px;}
        .has-child .font-icon:before{content: "\f103";font-size: 14px;}
        .sub-menu-item{
            &{font-size: 12px;}
            &:hover, &.active{color: #3993d1;background-color: rgba(0,0,0,.0175);}
        }
    }

    // menu default
    .menu-default{
        &{float: right;}
        .menu-item{
            &{padding: 37px 20px 0;height: 90px;float: left;}
            &:hover, &.active{
                &{box-shadow: inset 0 4px 0 0 #3993d1;}
                .menu-name, .font-icon{color: #3993d1;}
            }
            &:hover .sub-menu{display: block;}
        }
        .has-child .font-icon{margin-left: 5px;display: initial;}
        .sub-menu{position: absolute;left: auto;right: 0;top: 75px;z-index: 1000;display: none;white-space: nowrap;background-clip: padding-box;box-shadow: 0 3px 5px rgb(0 0 0 / 25%);padding: 9px 0;background-color: #fff;}
        .sub-menu-item{padding: 6px 19.2px;}
    }

    // menu mobile
    .menu-mobile{
        &{display: none;clear: both;padding: 25px 0;height: auto;}
        .menu-con, .sub-menu-item{margin: 0 0 -1px;border: 1px solid #f2f2f2;border-left: 0;border-right: 0;padding: 15px 0;}
        .sub-menu{margin-left: 34px;display: none;}
        .has-child .font-icon {position: absolute;top: 0;right: 0;bottom: 0;width: 35px;text-align: center;font-weight: 900;font-size: 18px;height: 51px;line-height: 51px;}
    }
    
    @media (min-width: 979px){
        .menu-mobile{display: none!important;}
    }
    @media (max-width: 978px){
        .navbar-wrap{height: auto;}
        .for-fixed{position: relative;}
        .menu-default{display: none;}
        .btn-navbar{display: block;}
    }
    @media (max-width: 768px){
        .breadcrumb{text-align: center;}
    }

    // footer
    .footer{padding: 20px 0;font-size: 10px;text-align: center;border-top: 1px solid rgba(0,0,0,.085);box-shadow: inset 0 1px 0 0 rgb(255 255 255 / 80%);background: #fff;}
    .footer-item{color: #3993d1;text-transform: uppercase;letter-spacing: 1px;cursor: pointer;margin: 0 5px;}
</style>